import { cannot } from '@/app/helpers'
import { processVariables } from '@/app/module/campaigns/store/selectors'
import { BackendCampaignTemplate } from '@/app/module/campaigns/types'
import type { LegacyCampaignDTO } from '@/app/module/campaigns/types/dtos'
import type { LegacyCampaignSaveData } from '@/app/module/campaigns/types/save-data'
import { processActionForSaving } from '@/app/module/campaigns/utils/process-actions'

import { prepareSMSSurvey } from './sms-survey'

/** Removes empty actions and resolves inherited sender IDs before saving a campaign. */
export const prepareActionsForSaving = (item: LegacyCampaignSaveData): LegacyCampaignDTO['variables'] => {
  switch (item.template) {
    case BackendCampaignTemplate.SMSSurvey:
      return prepareSMSSurvey(item)
    case BackendCampaignTemplate.CATI:
    case BackendCampaignTemplate.Chatbot:
    case BackendCampaignTemplate.Drip:
    case BackendCampaignTemplate.SMSBlast:
    case BackendCampaignTemplate.VoiceSurvey:
    case BackendCampaignTemplate.WhatsAppSurvey:
      return processVariables(item, processActionForSaving) as LegacyCampaignDTO['variables']
    default:
      return cannot(item)
  }
}
